import { useEffect, useRef } from 'react';
import css from './styles.module.css';

export const Ratio = ({ setRatio, customRatio }) => {
  const formRef = useRef(null);

  useEffect(() => {
    if (formRef.current[3].checked) {
      setRatio(formRef.current[3].value);
    }
  }, [customRatio, setRatio]);

  useEffect(() => {
    const previousSelection = localStorage.getItem('ratioSelection');

    if (previousSelection) {
      for (const input in formRef.current) {
        if (Object.hasOwnProperty.call(formRef.current, input)) {
          if (formRef.current[input].id === previousSelection) {
            formRef.current[input].checked = true;
          }
        }
      }
    }
  }, []);

  const handleChange = e => {
    const value = e.target.value;
    const id = e.target.id;
    setRatio(value);
    localStorage.setItem('ratioSelection', id);
  };

  const isDisabeled = () => {
    if (customRatio && customRatio !== '0') {
      return false;
    }
    return true;
  };

  return (
    <section className={css.main}>
      <h2>Styrke</h2>
      <form ref={formRef}>
        <div className={css.radioShack}>
          <input
            onChange={handleChange}
            type="radio"
            id="weak"
            name="coffeeRatio"
            value={18}
          />
          <label htmlFor="weak">
            Svak <span className="number">1:18</span>
          </label>
        </div>

        <div className={css.radioShack}>
          <input
            onChange={handleChange}
            type="radio"
            id="regular"
            name="coffeeRatio"
            value={17}
            defaultChecked
          />
          <label htmlFor="regular">
            Vanlig <span className="number">1:17</span>
          </label>
        </div>

        <div className={css.radioShack}>
          <input
            onChange={handleChange}
            type="radio"
            id="strong"
            name="coffeeRatio"
            value={16}
          />
          <label htmlFor="strong">
            Sterk <span className="number">1:16</span>
          </label>
        </div>

        <div className={css.radioShack}>
          <input
            onChange={handleChange}
            type="radio"
            id="customRatio"
            name="coffeeRatio"
            value={customRatio}
            disabled={isDisabeled()}
          />
          <label htmlFor="customRatio">
            Egendefinert{' '}
            {customRatio ? (
              <span className="number">1:{customRatio}</span>
            ) : null}
          </label>
        </div>
      </form>
    </section>
  );
};
